import React from "react";

import { useNavigate, useTranslation } from "utils";

import { Button, Col, Form, Link, Row } from "components";

interface SignInButtonsProps {
  loading: boolean;
}

export const SignInButtons = ({ loading }: SignInButtonsProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation("signinup");

  return (
    <>
      <Row>
        <Col className="left">
          <p>
            <Link dataTestId="forgot-password-link" to="/password" className="link green-text">
              {t("signin.buttons.password")}
            </Link>
          </p>
        </Col>
      </Row>
      <Row className="margin-top-325">
        <Col>
          <Form.Item>
            <Button dataTestId="sign-in-button" type="primary" htmlType="submit" disabled={loading} loading={loading}>
              {t("signin.buttons.signin")}
            </Button>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col>
          <Button
            type="secondary"
            onClick={() => navigate("/sign-up")}
            dataTestId="sign-up-button"
            disabled={loading}
            mixpanelText={t("signin.buttons.createAccount")}
          >
            {t("signin.buttons.createAccount")}
          </Button>
        </Col>
      </Row>
    </>
  );
};
